//yyyy-mm-dd hh:mm:ss
export const dateformat = (dates: string) => {
  var date = new Date(dates);
  var year = date.getFullYear().toString();

  var monthdate = date.getMonth() + 1;
  var month =
    monthdate < 10 ? "0" + monthdate.toString() : monthdate.toString();

  var daydate = date.getDate();
  var day = daydate < 10 ? "0" + daydate.toString() : daydate.toString();

  var hourdate = date.getHours();
  var hour = hourdate < 10 ? "0" + hourdate.toString() : hourdate.toString();

  var mindate = date.getHours();
  var min = mindate < 10 ? "0" + mindate.toString() : mindate.toString();

  var secdate = date.getHours();
  var sec = secdate < 10 ? "0" + secdate.toString() : secdate.toString();

  var now = year + "-" + month + "-" + day + " " + hour + ":" + min + ":" + sec;
  return now;
};

//yyyy-mm-dd
export const dateformat2 = (dates: string) => {
  var date = new Date(dates);
  var year = date.getFullYear().toString();

  var monthdate = date.getMonth() + 1;
  var month =
    monthdate < 10 ? "0" + monthdate.toString() : monthdate.toString();

  var daydate = date.getDate();
  var day = daydate < 10 ? "0" + daydate.toString() : daydate.toString();

  var now = year + "-" + month + "-" + day;
  return now;
};

export const filesList = (filePath: string) => {
  const normalizedPath = filePath.replace(/\\/g, "/");
  const parts = normalizedPath.split("/");
  const fileName = parts.pop();
  if (!fileName) return "";
  const folderPath = parts.join("/");
  const encodedFileName = fileName.replace(/ /g, "%20");
  return `${process.env.REACT_APP_FILE_API}${folderPath}/${encodedFileName}`;
};
